import api from '@pray/shared/utils/api';

export type RenderedEmailCampaign = {
  /** Liquid resolved against the campaign's own send date. */
  body: string;
  subject: string;
  preview: string;
  /** The date the catalog rows were resolved against. */
  rendered_for_date: string;
  /** False when the campaign uses no catalog tokens, or when its content could not resolve. */
  is_rendered: boolean;
  /** Set when a referenced catalog row no longer resolves for that date. */
  unavailable_reason: string | null;
};

/**
 * The campaign as it was actually delivered.
 *
 * Catalog rows are keyed by date and retained, so the server resolves the stored template
 * against the campaign's own send date rather than today.
 */
export async function getRenderedEmailCampaign({
  artistId = '',
  campaignId = '',
}: {
  artistId?: string;
  campaignId?: string;
}): Promise<{ data: { rendered: RenderedEmailCampaign } }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!campaignId) throw new Error('Campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/emails/${campaignId}/rendered`;
  // Two levels on purpose, matching every sibling here: the transport unwraps to the API
  // envelope, and the payload sits under `data` inside it. getEmailCampaign returns the
  // envelope the same way and its hook reaches through `.data` to get the record.
  const response = await api.executeGetRequest<{ data: { rendered: RenderedEmailCampaign } }>(url);

  return response.data;
}
